<template>
  <div class="page-wrapper">
    <img
      v-if="imageUrl"
      class="bg"
      :src="imageUrl"
      :style="{
        height: language == 'en-US' ? 'calc(8139 / 1080 * 100vw)' : 'calc(5903 / 1080 * 100vw)'
      }"
      alt=""
    />
  </div>
</template>

<script>
import { getData } from '@/request/api/model'

const CATEGORY_ID = '1985184895221714945'

export default {
  data() {
    return {
      language: localStorage.getItem('Language'),
      imageUrl: ''
    }
  },
  created() {
    this.getHistoryImage()
  },
  methods: {
    async getHistoryImage() {
      try {
        const res = await getData({
          categoryId: CATEGORY_ID,
          contentType: this.language === 'zh-CN' ? '0,1' : '0,2',
          publishChannel: '0,2'
        })

        if (!res || res.code !== 0 || !Array.isArray(res.data)) {
          return
        }

        const imageItem = res.data[0]

        if (imageItem) {
          this.imageUrl = imageItem.contentFileList.find((url) => {
            return typeof url === 'string' && url.trim()
          })
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>
<style scoped lang='scss'>
@import '../style.scss';
.bg {
  display: block;
  width: 100vw;
  height: calc(5903 / 1080 * 100vw);
}
</style>
